export default "/images/bf3a1138e2b89516cd9e71c311ac2652.avif";